// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","secondary_font":"Futura, sans-serif","mobile":"only screen and (max-width: 767px)","feeds":"feeds__3BX9f","label":"label__37xHx","redLine":"redLine__BHU0A","feedLogos":"feedLogos__3IGwR"};


//////////////////
// WEBPACK FOOTER
// ./components/Feeds/style.css
// module id = 9kQ4
// module chunks = 0